import React from 'react';

interface BreadcrumbProps {
  items: { label: string; onClick?: () => void }[];
  className?: string;
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className = '' }) => {
  return (
    <nav className={`flex items-center gap-2 text-base ${className}`} aria-label="Breadcrumb">
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {index > 0 && <span className="text-text-muted">/</span>}
          {item.onClick ? (
            <button
              onClick={item.onClick}
              className="text-text-primary hover:text-pickem-primary transition-colors font-gilroy"
            >
              {item.label}
            </button>
          ) : (
            <span className="text-text-muted font-gilroy">{item.label}</span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;
